<template lang="pug">
  div
    el-row(type='flex')
      el-col(:span="8").container-input
        app-label(label="Nome da demanda:", :required="false")
        el-input.input(
          v-model="filtro.nome"
          @blur="whitespace('nome')"
        )

      el-col(:span="8").container-input
        app-label(label="Data de início:", :required="false")
        el-date-picker#periodoInicio(
          v-model="filtro.periodoInicio"
          type="daterange"
          unlink-panels
          range-separator="até"
          start-placeholder="Início"
          end-placeholder="Fim"
          format="dd/MM/yyyy"
          :picker-options="pickerOptions"
        )

      el-col(:span="8")
        app-label(label="Data de entrega:", :required="false")
        el-date-picker#periodoEntrega(
          v-model="filtro.periodoEntrega"
          type="daterange"
          unlink-panels
          range-separator="até"
          start-placeholder="Início"
          end-placeholder="Fim"
          format="dd/MM/yyyy"
          :picker-options="pickerOptions"
        )

    el-row(type='flex')
      el-col(:span="8").container-input
        app-label(label="Responsável:", :required="false")
        el-select.input#responsavel(
          class="select",
          v-model="filtro.responsavel",
          placeholder="Selecione",
          value-key="id"
        )
          el-option(
            v-for="item in responsavelList",
            :key="item.id",
            :label="item.pessoa.nomeRazaoSocial",
            :value="item"
          )

      el-col(:span="8").container-input
        app-label(label="Estado da demanda:", :required="false")
        el-select.input#estadoDemanda(
          class="select",
          v-model="filtro.estadoDemanda",
          placeholder="Selecione",
          value-key="id"
        )
          el-option(
            v-for="item in estadoDemandaList",
            :key="item.id",
            :label="item.nome",
            :value="item"
          )

      el-col(:span="8")
        app-label(label="Prioridade:", :required="false")
        el-select.input#prioridade(
          class="select",
          v-model="filtro.prioridade",
          placeholder="Selecione",
          value-key="id"
        )
          el-option(
            v-for="item in prioridadeList",
            :key="item.id",
            :label="item.nome",
            :value="item"
          )
</template>

<script>
import AppLabel from '@/components/AppLabel'
import { mapActions } from 'vuex'

const UMA_SEMANA = new Date().getTime() - 3600 * 1000 * 24 * 7
const UM_MES = new Date().getTime() - 3600 * 1000 * 24 * 30
const TRES_MESES = new Date().getTime() - 3600 * 1000 * 24 * 90

export default {
  components: {
    AppLabel
  },

  props: {
    painel: {
      type: Object,
      required: true
    },

    filtro: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      responsavelList: [],
      estadoDemandaList: [],
      prioridadeList: [],
      pickerOptions: {
        shortcuts: [{
          text: 'Última semana',
          onClick (picker) {
            const end = new Date()
            const start = UMA_SEMANA
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Último mês',
          onClick (picker) {
            const end = new Date()
            const start = UM_MES
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Últimos 3 meses',
          onClick (picker) {
            const end = new Date()
            const start = TRES_MESES
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },

  methods: {
    ...mapActions({
      findPrioridades: 'prioridades/findAll',
      findEstadosDemandas: 'estados/findAll',
      findResponsaveis: 'paineis/getTimeById'
    }),

    getPrioridades: async function () {
      this.prioridadeList = await this.findPrioridades()
    },

    getEstadosDemandas: async function () {
      this.estadoDemandaList = await this.findEstadosDemandas()
    },

    getResponsaveis: async function (idPainel) {
      this.responsavelList = await this.findResponsaveis(idPainel)
    },

    whitespace (field) {
      if (this.filtro[field]) {
        this.filtro[field] = this.filtro[field].trim()
      }
    }
  },

  mounted: function () {
    if (this.painel) {
      this.getPrioridades()
      this.getEstadosDemandas()
      this.getResponsaveis(this.painel.id)
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.container {
  display: flex;
  flex-direction: row;
  padding: 5px;
}

.container-input {
  margin-right: 20px;
  margin-top: 0px;
  margin-bottom: 10px;
}

.select {
  width: 100%;
}

.el-date-editor--daterange.el-input__inner {
  width: 100%;
}
.el-date-editor >>> .el-range-separator {
  width: 20%;
}

.el-date-editor >>> .el-picker-panel__body {
  margin-left: 130px;
}

.el-date-editor
  >>> .el-picker-panel__body-wrapper
  >>> .el-picker-panel__sidebar {
  width: 130px;
}
</style>



// WEBPACK FOOTER //
// src/screens/demandas/components/PesquisaAvancadaDemandas.vue